import {
	Container,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Text,
	ContainerGutter,
	ReferenceBadge,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { HuchaDisclaimer1Text } from '../../disclaimers/hucha-disclaimers';
import { handleScrollToDisclaimer } from '../../../../../../helpers/disclaimers/disclaimers-utils';
import { useDisclaimers } from '../../../../../../context/disclaimers-context';
import { COLOR_TOKEN } from '../../../../../../helpers/color-tokens';
import { Super200ResponsiveText, Super200SymbolResponsiveText } from '../../ui/money-font-styles';

const MainContainer = styled(Container)`
	padding: 0px;

	/* Mobile */
	@media (max-width: 959px) {
		padding-top: 40px;
	}

	/* Desktop */
	@media (min-width: 960px) {
		padding-top: 18px;
		padding-left: var(--size-dynamic0100);
		padding-right: var(--size-dynamic0100);
	}
`;

const StyledC2Wrapper = styled(Container)`
	border-top: 2px solid ${COLOR_TOKEN.focus.main};
	border-bottom: 2px solid ${COLOR_TOKEN.focus.main};
	align-content: center;
	padding-left: 4px;
	padding-right: 4px;

	margin-left: auto;
	margin-right: auto;

	/* padding top and bottom depends on the fixed height */

	/* Mobile */
	@media (max-width: 959px) {
		height: 186px;
	}

	/* Tablet */
	@media (min-width: 960px) {
		height: 270px;
	}

	/* Desktop */
	@media (min-width: 1600px) {
		height: 214px;
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 20px;
`;

export const RenovadoresBonusCardC2: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	const { findBadge } = useDisclaimers();
	const badge = findBadge(HuchaDisclaimer1Text);

	return (
		<MainContainer stretchContent data-testid="c2-container">
			<StyledC2Wrapper
				data-testid="c2-inner-container"
				stretchContent
				wrap="always"
				verticalAlign="center"
				horizontalAlign="center"
				gutter={ContainerGutter.dynamic0020}
			>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.center}
					bold
				>
					{'Llevas acumulado'}
				</Text>
				<Container wrap="never" horizontalAlign="center">
					<Container wrap="never" verticalAlign="flex-end">
						<Super200ResponsiveText color={TokenTextColor.inverted}>{dineroHucha}</Super200ResponsiveText>
						<Super200SymbolResponsiveText color={TokenTextColor.inverted}>{'€'}</Super200SymbolResponsiveText>
					</Container>
					{badge && (
						<StyledReferenceBadge
							variant="large"
							onClick={() => {
								if (badge) handleScrollToDisclaimer(badge);
							}}
						>
							{badge.replace(/\.$/, '')}
						</StyledReferenceBadge>
					)}
				</Container>
			</StyledC2Wrapper>
		</MainContainer>
	);
};
